import styled from 'styled-components';

import { PULSE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const Grid = styled.div<{ $oneCol: boolean }>`
  display: grid;
  /* Two-up by default; collapses to a single full-row column when the figures
   * would otherwise overflow their half-width cards (decided in JS — see
   * ThisMonth.tsx — because it depends on the rendered number width, not the
   * viewport, which CSS alone can't read). */
  grid-template-columns: ${(p) => (p.$oneCol ? '1fr' : '1fr 1fr')};
  gap: 5px;
`;

/** One metric tile — icon left, text column right; a tinted panel with NO border
 *  (Figma: bg rgba(45,45,51,0.33), 16px radius). */
export const Metric = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: ${PULSE.panel};
  border-radius: 16px;
  padding: 12px;
  min-width: 0;
`;

export const IconSlot = styled.span`
  display: flex;
  flex: none;

  img {
    width: 30px;
    height: 30px;
    display: block;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
`;

export const Label = styled(Text)`
  font-size: 16px;
  color: ${PULSE.t300};
  min-width: 0;
`;

export const Value = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${PULSE.t50};
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
  white-space: nowrap;
`;

/** Inline wrapper around the figure so its intrinsic single-line width can be
 *  measured regardless of the current column layout — that measurement drives
 *  the 1-vs-2-column decision in ThisMonth.tsx. */
export const ValueText = styled.span`
  display: inline-block;
  white-space: nowrap;
`;

export const Foot = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Note = styled(Text)<{ $green: boolean }>`
  font-size: 13px;
  letter-spacing: -0.0762px;
  color: ${(p) => (p.$green ? PULSE.success : PULSE.t600)};
`;
